import { Injectable } from '@angular/core';

const TOKEN_KEY = 'transportista_gateway_jwt';
const USER_JSON_KEY = 'transportista_gateway_user';

/**
 * JWT y snapshot opcional del usuario gateway.
 * Se usa localStorage para el token (misma UX que el login legacy ante F5 / recarga).
 */
@Injectable({ providedIn: 'root' })
export class TransportistaSessionStorage {
  getToken(): string | null {
    try {
      return localStorage.getItem(TOKEN_KEY);
    } catch {
      return null;
    }
  }

  setToken(token: string): void {
    localStorage.setItem(TOKEN_KEY, token);
  }

  clearToken(): void {
    localStorage.removeItem(TOKEN_KEY);
  }

  getUser<T = unknown>(): T | null {
    try {
      const raw = localStorage.getItem(USER_JSON_KEY);
      if (!raw) {
        return null;
      }
      return JSON.parse(raw) as T;
    } catch {
      return null;
    }
  }

  setUser(user: unknown): void {
    localStorage.setItem(USER_JSON_KEY, JSON.stringify(user));
  }

  clearUser(): void {
    localStorage.removeItem(USER_JSON_KEY);
  }

  clearAll(): void {
    this.clearToken();
    this.clearUser();
  }

  /** `true` si no hay token o el claim `exp` del JWT ya venció. */
  isTokenExpired(): boolean {
    const token = this.getToken();
    if (!token) {
      return true;
    }
    const exp = this.parseJwtExp(token);
    if (exp == null) {
      return false;
    }
    return Date.now() >= exp * 1000;
  }

  private parseJwtExp(token: string): number | null {
    try {
      const parts = token.split('.');
      if (parts.length < 2) {
        return null;
      }
      const payload = JSON.parse(
        atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'))
      );
      const exp = payload?.exp;
      return typeof exp === 'number' ? exp : null;
    } catch {
      return null;
    }
  }
}
